import { QuestionInputValue } from '../input-value-types'
import QuestionViewModelBase from '../QuestionViewModelBase'

export default class UnknownQuestionViewModel extends QuestionViewModelBase<any> {
  get isAnswered(): boolean {
    return true
  }

  protected textAnswer(): string {
    return ''
  }

  protected hydrateAnswer(_: unknown): void {
    //
  }

  protected serializeAnswer() {
    return undefined
  }

  toInputValue(): QuestionInputValue {
    return { type: 'UNKNOWN', value: 'UNKNOWN' }
  }
}
